/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Status_CanceledInputs */

const en_tasks_status_canceled = /** @type {(inputs: Tasks_Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

const fr_tasks_status_canceled = /** @type {(inputs: Tasks_Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulée`)
};

const ms_sg2_tasks_status_canceled = /** @type {(inputs: Tasks_Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibatalkan`)
};

/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {Tasks_Status_CanceledInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_status_canceled = /** @type {((inputs?: Tasks_Status_CanceledInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Status_CanceledInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_status_canceled(inputs)
	if (locale === "fr") return fr_tasks_status_canceled(inputs)
	return ms_sg2_tasks_status_canceled(inputs)
});